/**
 * @author Giorgi Torghvashvili
 */

export const useMyComposable = () => {
  const config = useRuntimeConfig();

  return {
    apiUrl: config.public.BASE_API_URL,
    websiteUrl: config.public.BASE_URL,
    authUrl: config.public.AUTH_URL,
    logoutUrl: config.public.LOGOUT_URL,
  };
};
